import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17331 17333"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M8021 0c48 36 92 77 143 107 1230 711 2460 1421 3690 2131 59 33 116 69 197 118-1357 783-2698 1557-4069 2348V3339c-1568 235-2796 982-3725 2250-514-359-1020-713-1544-1079 613-882 1380-1579 2298-2113 914-532 1900-842 2976-954V0h34zM1435 9354H0c791-1372 1566-2715 2351-4076 786 1361 1560 2701 2350 4070H3336c235 1575 988 2803 2249 3730-363 518-717 1026-1084 1551-1792-1315-2799-3065-3066-5275zM14976 12055c-785-1361-1559-2701-2349-4069h1363c-234-1575-989-2803-2249-3731 363-517 718-1024 1086-1549 1788 1316 2798 3065 3065 5269h1439c-794 1376-1569 2718-2355 4080zM9352 12626v1366c1568-232 2794-987 3722-2246 517 363 1023 718 1548 1086-1314 1788-3059 2793-5265 3062v1439c-1378-795-2718-1568-4079-2354 1359-785 2698-1559 4074-2353z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
